/**
 * API-Konfiguration
 *
 * In Production: Wenn die App von derselben Domain geladen wird, wird immer
 * relatives "/api" verwendet, damit Nginx korrekt weiterleitet – unabhängig
 * von VITE_API_URL (vermeidet 404 bei falsch gesetzter VITE_API_URL ohne /api).
 */

function getApiBaseURL(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    // Gleiche Origin → immer relatives /api (Proxy-Regel)
    if (!envUrl || envUrl === origin || envUrl.replace(/\/$/, '') === origin) {
      return '/api';
    }
    if (envUrl.startsWith('http')) return envUrl.replace(/\/?$/, '');
  }
  return envUrl || '/api';
}

export const apiConfig = {
  // Backend API URL
  baseURL: getApiBaseURL(),
  
  // WebSocket URL
  socketURL: import.meta.env.VITE_SOCKET_URL || '',
  
  // Timeouts
  timeout: 30000,
  
  // Retry-Konfiguration
  retryAttempts: 3,
  retryDelay: 1000,
};

export default apiConfig;
